import { render, staticRenderFns } from "./PreviewPhotos.vue?vue&type=template&id=55980cda&scoped=true&"
import script from "./PreviewPhotos.vue?vue&type=script&lang=js&"
export * from "./PreviewPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPhotos.vue?vue&type=style&index=0&id=55980cda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55980cda",
  null
  
)

export default component.exports